import React, { Component } from "react";
import { Routes, Route, Link, Navigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

import AuthService from "./services/auth.service";

import Login from "./components/login.component";
import Register from "./components/register.component";
import Home from "./components/home.component";
import Fichar from "./components/fichar.component";
import Gracias from "./components/Gracias";
import BoardUser from "./components/board-user.component";
import BoardModerator from "./components/board-moderator.component";
import BoardAdmin from "./components/board-admin.component";
import Update from "./components/update";
import Expanmetal from "./components/expanmetal.component";
import Solicitudes from "./components/solicitudes.component";

class App extends Component {
  constructor(props) {
    super(props);
    this.logOut = this.logOut.bind(this);

    this.state = {
      showModeratorBoard: false,
      showAdminBoard: false,
      currentUser: undefined,
      redirectToLogin: false
    };
  }

  componentDidMount() {

    const user = AuthService.getCurrentUser();

    console.log(user);
    if (user) {
      this.setState({
        currentUser: user,
        showModeratorBoard: user.roles.includes("ROLE_MODERATOR"),
        showAdminBoard: user.roles.includes("ROLE_ADMIN"),
        showUser: user.roles.includes("ROLE_USER")
      });
      console.log('ooooooooooo');
    }else{
        console.log('saliiiiiii');
        AuthService.logout();
        this.setState({ redirectToLogin: true });
    }

  }

  logOut() {
    AuthService.logout();
  }

  render() {
    const { currentUser, showModeratorBoard, showAdminBoard, showUser, redirectToLogin } = this.state;

    return (
      <>
      <Update />
        <div>
          {redirectToLogin && (
            <Navigate to="/login" replace />
          )}
          <nav className="navbar navbar-expand navbar-dark bg-dark py-2">
            <div className="container-fluid">
              <Link to="/" className="navbar-brand fw-semibold text-uppercase" aria-label="Industria Basica S.A. Stock 3.0">
                <span className="d-none d-sm-inline">Industria Basica S.A. Stock 3.0</span>
                <span className="d-inline d-sm-none">ST 3.0</span>
              </Link>
              <div className="navbar-nav me-auto">
                {currentUser && (
                  <li className="nav-item">
                    <Link to="/user" className="nav-link"></Link>
                  </li>
                )}
              </div>

              {showUser ? (
                <div className="navbar-nav ms-auto">
                  <li className="nav-item">
                    <span className="nav-link disabled" aria-disabled="true" title="Perfil deshabilitado">
                      {currentUser.username}
                    </span>
                  </li>
                  <li className="nav-item">
                    <a href="/" className="nav-link" onClick={this.logOut}>
                      Salir
                    </a>
                  </li>
                </div>
              ) : (
                <div className="navbar-nav ms-auto">
                  <li className="nav-item">
                    <Link to="/login" className="nav-link">
                      Ingresar
                    </Link>
                  </li>
                </div>
              )}
            </div>
          </nav>

          <div className="container-fluid mt-3" style={{overflow: 'auto'}}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/home" element={<Home />} />
              <Route path="/fichar" element={<Fichar />} />
              <Route path="/expanmetal" element={<Expanmetal />} />
              <Route path="/solicitudes" element={<Solicitudes />} />
              <Route path="/gracias" element={<Gracias />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/user" element={<BoardUser />} />
              <Route path="/mod" element={<BoardModerator />} />
              <Route path="/admin" element={<BoardAdmin />} />
            </Routes>
          </div>


        </div>
      </>
    );
  }
}

export default App;